import React from 'react'
import NoPadH3 from '../../titles/NoPadH3'
import Divider from '../../Divider'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'


const goals = [
  {id:1, name: "Goal 01", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:2, name: "Goal 02", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:3, name: "Goal 03", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:4, name: "Goal 04", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:5, name: "Goal 05", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:6, name: "Goal 01", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:7, name: "Goal 02", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:8, name: "Goal 03", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:9, name: "Goal 04", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
  {id:10, name: "Goal 05", desc: "Minim esse officia laborum veniam minim mollit.", createdAt: "01-01-2022", reachedAt:"27-06-2022", reached: true},
]

const Reached = () => {
  return (<>
    <NoPadH3>Reached</NoPadH3>
    <Divider />
    <div className='d-flex flex-wrap p-2'>
      {goals.map(g => <div key={g.id} style={{maxWidth:"240px"}} className='p-4 m-2 rounded shadow'>
        <div className='d-flex justify-content-between mb-2'>
          <p className='fs-3'>{g.name}</p>
          <FontAwesomeIcon style={{color: "turquoise"}} className='fs-1' icon={faCheck} /> 
        </div>
        <p>{g.desc}</p>
        <p className='mt-4'>Created: {g.createdAt}</p>
        <p>Reached: {g.reachedAt}</p>
        <Button className='w-100 mt-3' variant='outline-danger'>Remove</Button>
      </div>)}
    </div>
  </>)
}

export default Reached